import { CellProps, VisitCellProps, VisitRequestCellProps } from '@/components/bulkQueue/types';
import { TentativeDateDisplay } from '@/components/dates/CommonDateDisplays';
import { NoneLabel } from '@/components/labels/NoneLabel';
import { VisitDateTypeDisplay } from '@/components/visits/VisitDateTypeDisplay';
import { FC } from 'react';

const DATE_PROPS = {
    fontSize: '14px',
};

const LABEL_PROPS = {
    fontSize: '10px',
};

const DateVisitRequestCell: FC<VisitRequestCellProps> = (props) => {
    const { tentativeDate } = props.entity;

    if (tentativeDate) {
        return (
            <TentativeDateDisplay
                tentativeDate={tentativeDate}
                dateProps={DATE_PROPS}
                labelProps={LABEL_PROPS}
            />
        );
    }

    return <NoneLabel {...DATE_PROPS} />;
};

const DateVisitCell: FC<VisitCellProps> = (props) => {
    return (
        <VisitDateTypeDisplay
            {...props.entity}
            fallbackDate={null}
            labelProps={LABEL_PROPS}
            datetimeProps={DATE_PROPS}
            displayFulfillmentWindow={false}
        />
    );
};

export const DateRenderCell: FC<CellProps> = (props) => {
    const { entity } = props;

    switch (entity.__typename) {
        case 'Visit':
            return <DateVisitCell entity={entity} />;
        case 'VisitRequest':
            return <DateVisitRequestCell entity={entity} />;
        default:
            return null;
    }
};
